import { combineReducers } from "redux";

import calls from "./callsReducer";
import lines from "./linesReducer";
import login from "./loginReducer";
import page from "./pageReducer";
import profiles from "./profilesReducer";
import topics from "./topicsReducer";
import push from "./pushReducer";

export const rootReducer = combineReducers({
  calls,
  lines,
  login,
  page,
  profiles,
  topics,
  push,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.ts